import React, { useEffect } from 'react';
import { configureHeyImmoWidget } from './heyImmoWidgetUtils';
import { useAppSelector } from '../../store/store';
var EMPTY_AGENTS = [];
var selectHeyImmoWidgetEnabled = function selectHeyImmoWidgetEnabled(state) {
  var _state$config;
  return (_state$config = state.config) === null || _state$config === void 0 ? void 0 : _state$config.SHOW_HEY_IMMO_WIDGET;
};
var selectChatBotWidgetScript = function selectChatBotWidgetScript(state) {
  var _state$config2;
  return (_state$config2 = state.config) === null || _state$config2 === void 0 ? void 0 : _state$config2.CHAT_BOT_WIDGET_SCRIPT_URL;
};
var selectSearchLocation = function selectSearchLocation(state) {
  var _state$gacOverAllInfo;
  return ((_state$gacOverAllInfo = state.gacOverAllInfo) === null || _state$gacOverAllInfo === void 0 || (_state$gacOverAllInfo = _state$gacOverAllInfo.selectedSuggestion) === null || _state$gacOverAllInfo === void 0 ? void 0 : _state$gacOverAllInfo.name) || '';
};
var selectTotalAgents = function selectTotalAgents(state) {
  var _state$search;
  return ((_state$search = state.search) === null || _state$search === void 0 ? void 0 : _state$search.totalNumberOfAgents) || 0;
};
var selectIsBranchenbuchSearch = function selectIsBranchenbuchSearch(state) {
  var _state$branchenbuchSe;
  return ((_state$branchenbuchSe = state.branchenbuchSearch) === null || _state$branchenbuchSe === void 0 ? void 0 : _state$branchenbuchSe.isBranchenbuchSearch) || false;
};
var selectPageResults = function selectPageResults(state) {
  var _state$search2;
  return ((_state$search2 = state.search) === null || _state$search2 === void 0 ? void 0 : _state$search2.pageResults) || EMPTY_AGENTS;
};
var PROMPT_SUGGESTIONS = ['Wie finde ich den besten Makler?', 'Warum sollte ich mit Makler verkaufen?', 'Was ist meine Immobilie wert?'];
var HeyImmoWidgetComponent = function HeyImmoWidgetComponent() {
  var isWidgetEnabled = useAppSelector(selectHeyImmoWidgetEnabled);
  var chatBotWidgetScript = useAppSelector(selectChatBotWidgetScript);
  var searchLocation = useAppSelector(selectSearchLocation);
  var totalAgents = useAppSelector(selectTotalAgents);
  var isBranchenbuchSearch = useAppSelector(selectIsBranchenbuchSearch);
  var pageResults = useAppSelector(selectPageResults);
  if (!isWidgetEnabled || !chatBotWidgetScript) return null;
  useEffect(function () {
    var scriptId = 'heyImmo-widget-script';
    var existingScript = document.getElementById(scriptId);
    if (existingScript) {
      return;
    }
    var script = document.createElement('script');
    script.id = scriptId;
    script.src = chatBotWidgetScript;
    script.async = true; // Non-blocking, asynchronous loading

    // Configure the widget with prompt suggestions after the script loads
    script.onload = function () {
      configureHeyImmoWidget(PROMPT_SUGGESTIONS);
    };
    document.body.appendChild(script);
    return function () {
      var scriptToRemove = document.getElementById(scriptId);
      if (scriptToRemove) {
        scriptToRemove.remove();
      }
    };
  }, [chatBotWidgetScript]);

  // Find the top 3 rated agents from current page results
  var getTopRatedAgents = function getTopRatedAgents() {
    if (pageResults.length === 0) return [];
    var agentsWithRatings = pageResults.filter(function (agent) {
      var _agent$evaluations;
      return (_agent$evaluations = agent.evaluations) === null || _agent$evaluations === void 0 ? void 0 : _agent$evaluations.averageRating;
    });
    if (agentsWithRatings.length === 0) return [];
    return agentsWithRatings.sort(function (a, b) {
      var _a$evaluations, _b$evaluations;
      var ratingA = ((_a$evaluations = a.evaluations) === null || _a$evaluations === void 0 ? void 0 : _a$evaluations.averageRating) || 0;
      var ratingB = ((_b$evaluations = b.evaluations) === null || _b$evaluations === void 0 ? void 0 : _b$evaluations.averageRating) || 0;
      return ratingB - ratingA;
    }).slice(0, 3);
  };
  var topRatedAgents = getTopRatedAgents();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    id: "ai-chat-bot",
    "data-heyimmo-page": "agent-search",
    "data-testid": "heyimmo-widget-container"
  }), /*#__PURE__*/React.createElement("div", {
    "data-heyimmo-context": "page-type",
    style: {
      display: 'none'
    }
  }, "Agent Search / Immobilienmakler Suche"), searchLocation && /*#__PURE__*/React.createElement("div", {
    "data-heyimmo-context": "search-location",
    style: {
      display: 'none'
    }
  }, searchLocation), totalAgents > 0 && /*#__PURE__*/React.createElement("div", {
    "data-heyimmo-context": "total-agents-found",
    style: {
      display: 'none'
    }
  }, totalAgents), isBranchenbuchSearch && /*#__PURE__*/React.createElement("div", {
    "data-heyimmo-context": "search-type",
    style: {
      display: 'none'
    }
  }, "Branchenbuch (Yellow Pages)"), topRatedAgents.map(function (agent, index) {
    var _agent$evaluations2, _agent$evaluations3;
    return /*#__PURE__*/React.createElement("div", {
      key: agent.id || index,
      "data-heyimmo-context": "top-agent-".concat(index + 1),
      style: {
        display: 'none'
      }
    }, agent.name, " - ", (_agent$evaluations2 = agent.evaluations) === null || _agent$evaluations2 === void 0 ? void 0 : _agent$evaluations2.averageRating, "/5 stars (", (_agent$evaluations3 = agent.evaluations) === null || _agent$evaluations3 === void 0 ? void 0 : _agent$evaluations3.overallNumberOfEvaluations, " reviews)");
  }), /*#__PURE__*/React.createElement("div", {
    "data-heyimmo-context": "page-description",
    style: {
      display: 'none'
    }
  }, "User is viewing a list of real estate agents in their searched location. They can filter agents, view agent details, and contact agents from this page."));
};
export var HeyImmoWidget = /*#__PURE__*/React.memo(HeyImmoWidgetComponent);
export { openImmoGpt, openImmoGptEmpty, configureHeyImmoWidget } from './heyImmoWidgetUtils';